import { render, staticRenderFns } from "./ProofOfPayment.vue?vue&type=template&id=c36cb84a&scoped=true&"
import script from "./ProofOfPayment.vue?vue&type=script&lang=js&"
export * from "./ProofOfPayment.vue?vue&type=script&lang=js&"
import style0 from "./ProofOfPayment.vue?vue&type=style&index=0&id=c36cb84a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36cb84a",
  null
  
)

export default component.exports